<mat-card class="upcomingEventCard">
    <mat-card-header>
        <mat-card-title>
            {{ event.title }}
            <span *ngIf="event.ongoing" style="font-weight: bold;">
                ONGOING
            </span>
        </mat-card-title>
        <mat-card-subtitle>
            <span *ngIf="!event.ongoing; else started"> Starts </span>
            <ng-template #started> Started </ng-template>
            {{ event.dtstart.calendar() }}
        </mat-card-subtitle>
        <mat-card-subtitle *ngIf="event.dtend">
            Ends {{ event.dtend.calendar() }}
        </mat-card-subtitle>
        <mat-card-subtitle *ngIf="event.recurringFrequency">
            {{ event.recurringFrequency }} event
        </mat-card-subtitle>
        <mat-card-subtitle *ngIf="event.location">
            Location: {{ event.location }}
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <p>
            {{ event.description }}
        </p>
    </mat-card-content>
    <mat-card-actions>
        <button mat-button *ngIf="editable" (click)="edit.emit()"> Edit </button>
    </mat-card-actions>
</mat-card>
